import styles from './ScoreLine.module.css'
import clsx from 'clsx'
import { BasicStyledComponent, DSVar } from 'shared-definitions/types'
import Score from 'shared-components/ui/Score'

interface ScoreLineProps extends BasicStyledComponent {
  score: DSVar<number>
}

const ScoreLine: React.VFC<ScoreLineProps> = ({ className, score }) => (
  <div className={clsx(styles.container, className)}>
    {score.name}
    <div className={styles.line} />
    <Score score={score.value} className={styles.score} />
  </div>
)

export default ScoreLine
